import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import Formsy from "formsy-react";
import { Input, Checkbox } from "formsy-react-components";
import { Row, Col } from "react-bootstrap";

const TaskForm = ({
  onAddTask,
  task,
  onEditTask,
  onCancel,
  adding,
  saving
}) => {
  let form = useRef();
  const [inputs, setInputs] = useState({
    status: true,
    description: ""
  });

  const [isValidForm, setIsValidForm] = useState(false);

  useEffect(() => {
    if (!adding) {
      setInputs(task);
    }
  }, [adding, task]);

  const submit = (values) => {
    form.reset();
    if (adding) {
      onAddTask(values);
    } else {
      values.id = inputs._id;
      onEditTask(values);
    }
  };

  const cancel = () => {
    onCancel();
  };

  return (
    <Formsy
      ref={(ref) => (form = ref)}
      className="vertical form"
      onValidSubmit={submit}
      onValid={() => setIsValidForm(true)}
      onInvalid={() => setIsValidForm(false)}
    >
      <Row>
        <Col md={4}>
          <Input
            formNoValidate
            name="description"
            label="Description"
            placeholder="Description"
            value={inputs.description}
            validations={{ maxLength: 250 }}
            validationErrors={{
              maxLength: "You can not type in more than 250 characters"
            }}
          />
        </Col>
        <Col md={2}>
          <Checkbox
            formNoValidate
            name="status"
            valueLabel="Active"
            value={inputs.status}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12} className="footer">
          <button type="button" className="btn  btn-cancel" onClick={cancel}>
            Cancel
          </button>
          <input
            className="btn  btn-success"
            type="submit"
            disabled={!isValidForm || saving}
            value={saving ? "Saving... " : "Save"}
          />
        </Col>
      </Row>
    </Formsy>
  );
};

TaskForm.propTypes = {
  onEditTask: PropTypes.func,
  saving: PropTypes.bool,
  task: PropTypes.object,
  onAddTask: PropTypes.func,
  onCancel: PropTypes.func,
  adding: PropTypes.bool
};

TaskForm.defaultProps = {
  adding: false
};
export default TaskForm;
